<script type="application/javascript">

export default {
    props: ['first', 'allPlans'],
    data() {
        return {
            deal: null,
            plan: null,
            calculatorCheckoutOpen: false,
            years: 1,
            busy: false,
            tools: [
                {
                    name: 'Notion',
                    img: '/img/notion/notion-icon.svg',
                    price: 180,
                    link: '/notion-alternative'
                },
                {
                    name: 'Asana',
                    img: '/img/new-homepage/save-big/asana-logo.png',
                    price: 300,
                    link: '/asana-alternative'
                },
                {
                    name: 'Monday',
                    img: '/img/new-homepage/save-big/monday-logo.png',
                    price: 228,
                    link: '/monday-alternative'
                },
                {
                    name: 'ClickUp',
                    img: '/img/new-homepage/save-big/clickup-logo.png',
                    price: 144,
                    link: '/blog/clickup-alternatives'
                },
                {
                    name: 'Airtable',
                    img: '/img/new-homepage/save-big/airtable-logo.png',
                    price: 240,
                    link: '/airtable-alternative'
                }
            ],
            plansType: 'yearly',
            plans: [],
            activePlan: null,
        };
    },
    mounted() {
        // this.activePlan = this.plans[0];
        this.plans = JSON.parse(this.allPlans).filter(plan => plan.type == 'pro' && plan.name !== 'Custom');
        this.activePlan = Object.values(this.plans)[0];
        this.$eventHub.$on('toggleCalculatorOpenCheckout', function () {
            this.calculatorCheckoutOpen = !this.calculatorCheckoutOpen;
        }.bind(this));
        // if(this.deals) {
        //     this.plan = this.deals[0];
        // }
        // // this.plan = this.deals['team_v3'];
        // if(this.plan) {
        //     this.deal = this.plan.id;
        // }
        const sorter = (a, b) => {
            if(a.name === this.first){
                return -1;
            }
            if(b.name === this.first){
                return 1;
            }
            return a.name < b.name ? -1 : 1;
        };
        this.tools.sort(sorter);
    },
    methods: {
        increaseYear() {
            if(this.years < 10) {
                this.years++;
            }
        },
        decreaseYear() {
            if(this.years > 1) {
                this.years--;
            }
        },
        changeActivePlan(plan) {
            this.activePlan = this.plans[plan];
            // this.deal = this.plan.id;
            dataLayer.push({
                event: 'clickOnPlanCalculator',
                plan: this.activePlan.id,
                // GA4
                section: 'Calculator',
                plansType: this.plansType
            });
        },
        
        openCheckout(deal) {
            // this.deal = this.plan.id;
            this.deal = deal;
            this.calculatorCheckoutOpen = true;
            dataLayer.push({
                event: 'clickOpenCheckoutCalculator',
                plan: this.deal.id
            });
        },
        sendToRegister(deal) {
            let url = `http://app.startinfinity.com/register?deal=${deal.id}&price=${this.plansType}`;
            var newTab = window.open(url, '_blank');
            // Focus on the new tab
            newTab.focus();
        },
        // changePlan(plan) {
        //     this.plan = this.deals[plan];
        //     this.deal = this.plan.id;
        //     dataLayer.push({
        //         event: 'clickOnPlanCalculator',
        //         plan: this.deal
        //     });
        // },
        // selectPlanNew() {
        //     // this.deal = this.plan.id;
        //     this.checkoutExpOpen = true;
        //     setTimeout(function(){
        //         let el = document.getElementById('checkout-calculator-modal-wrapper');
        //         if(el){
        //             el.classList.add('d-flex');
        //         }
        //         document.getElementById('popup-overlay').classList.add('d-block');
        //     }, 300);
        //     dataLayer.push({
        //         event: 'clickOpenCheckoutCalculator',
        //         plan: this.deal
        //     });
        // },

    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/PricingCalculator.vue